// extracted by mini-css-extract-plugin
export var pageLoading = "PageLoadingSpinner-module__pageLoading___SDyqx";